import React from "react";
import "./style.sass";
import {employeeAccountCards} from "./data";


const EmployeeAccount = () => {
    return (
        <div className={'employee-account'}>
            <div className={'employee-account__title'}>Кабинет сотрудника</div>
            <div className={'employee-account__cards-wrapper'}>{employeeAccountCards.map(({id, image, title}) => {
                return <div key={id} className={'employee-account__card'}>
                    <img src={image.url} className={'employee-account__card-img'} alt={image.alt}/>
                    <div className={'employee-account__card-title'}>{title}</div>
                </div>
            })}
            </div>

        </div>
    );
};

export default EmployeeAccount;